"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addForceStateSelectors = exports.applyStylableForceStateSelectors = exports.createDataAttr = exports.MATCH_STATE_ATTR = exports.MATCH_STATE_CLASS = exports.OVERRIDE_STATE_PREFIX = void 0;
const core_1 = require("@stylable/core");
const css_selector_parser_1 = require("@tokey/css-selector-parser");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
__exportStar(require("./create-forcestate-matchers"), exports);
// This transformation is applied on target AST code
// Not Stylable source AST
const nativePseudoClassesMap = core_1.nativePseudoClasses.reduce((acc, name) => {
    acc[name] = true;
    return acc;
}, {});
exports.OVERRIDE_STATE_PREFIX = 'stylable-force-state-';
const { hasOwnProperty } = Object.prototype;
exports.MATCH_STATE_CLASS = new RegExp(`^(.+?)${core_1.pseudoStates.booleanStateDelimiter}(.+)`);
exports.MATCH_STATE_ATTR = new RegExp(`^class~="(.+?)${core_1.pseudoStates.booleanStateDelimiter}(.+)"`);
function createDataAttr(dataAttrPrefix, stateName, param) {
    const paramWithValueExtraDil = param !== undefined ? core_1.pseudoStates.stateMiddleDelimiter : '';
    const statePart = param !== undefined ? core_1.pseudoStates.resolveStateParam(param) : '';
    return `${dataAttrPrefix}${paramWithValueExtraDil}${stateName}${statePart}`;
}
exports.createDataAttr = createDataAttr;
function applyStylableForceStateSelectors(outputAst, namespaceMapping = {}, dataPrefix = exports.OVERRIDE_STATE_PREFIX, plugin = (id) => id) {
    const isKnownNamespace = typeof namespaceMapping === 'function'
        ? namespaceMapping
        : (name) => hasOwnProperty.call(namespaceMapping, name);
    const mapping = {};
    addForceStateSelectors(outputAst, plugin({
        getForceStateAttrContentFromNative(name) {
            return this.getForceStateAttrContent(name);
        },
        getForceStateAttrContent(name) {
            return dataPrefix + name;
        },
        getStateClassName(name) {
            const parts = name.match(exports.MATCH_STATE_CLASS);
            return parts[2];
        },
        getStateAttr(content) {
            const parts = content.match(exports.MATCH_STATE_ATTR);
            return parts[2];
        },
        isStateClassName(name) {
            const parts = name.match(exports.MATCH_STATE_CLASS);
            return parts ? isKnownNamespace(parts[1]) : false;
        },
        isStateAttr(content) {
            const parts = content.match(exports.MATCH_STATE_ATTR);
            return parts ? isKnownNamespace(parts[1]) : false;
        },
        onMapping(key, value) {
            mapping[key] = value;
            mapping[value] = key;
        },
    }));
    return mapping;
}
exports.applyStylableForceStateSelectors = applyStylableForceStateSelectors;
function addForceStateSelectors(ast, context) {
    ast.walkRules((rule) => {
        const selectorAst = (0, css_selector_parser_1.parseCssSelector)(rule.selector);
        const overrideSelectors = selectorAst.reduce((selectors, selector) => {
            if (hasStates(selector, context)) {
                selectors.push(transformStates((0, lodash_clonedeep_1.default)(selector), context));
            }
            return selectors;
        }, []);
        if (overrideSelectors.length) {
            selectorAst.push(...overrideSelectors);
            rule.selector = (0, css_selector_parser_1.stringifySelectorAst)(selectorAst);
        }
    });
}
exports.addForceStateSelectors = addForceStateSelectors;
function isNative(name) {
    return hasOwnProperty.call(nativePseudoClassesMap, name);
}
function hasStates(selector, context) {
    let hasStates = false;
    (0, css_selector_parser_1.walk)(selector, (node) => {
        if (node.type === 'pseudo_class' ||
            (node.type === 'class' && context.isStateClassName(node.value)) ||
            (node.type === 'attribute' && node.value && context.isStateAttr(node.value))) {
            hasStates = true;
            return css_selector_parser_1.walk.skipNested;
        }
        return;
    });
    return hasStates;
}
function convertToAttribute(node) {
    const castNode = node;
    castNode.type = `attribute`;
    return castNode;
}
function transformStates(selector, context) {
    (0, css_selector_parser_1.walk)(selector, (node) => {
        if (node.type === 'pseudo_class') {
            const name = node.value;
            convertToAttribute(node).value = isNative(node.value)
                ? context.getForceStateAttrContentFromNative(node.value)
                : context.getForceStateAttrContent(node.value);
            context.onMapping(name, node.value);
        }
        else if (node.type === 'class' && context.isStateClassName(node.value)) {
            const name = context.getStateClassName(node.value);
            convertToAttribute(node).value = context.getForceStateAttrContent(name);
            context.onMapping(name, node.value);
        }
        else if (node.type === 'attribute' && node.value && context.isStateAttr(node.value)) {
            const name = context.getStateAttr(node.value);
            convertToAttribute(node).value = context.getForceStateAttrContent(name);
            context.onMapping(name, node.value);
        }
    });
    return selector;
}
//# sourceMappingURL=stylable-forcestates-plugin.js.map